import type { MessageInstance } from 'antd/es/message/interface';

/** Holder mutable para la instancia de message de App.useApp().
 *  Permite que código no-React (ej. interceptores de Axios) dispare toasts
 *  que respeten ConfigProvider sin depender del API estático de antd. */
export let messageApi: MessageInstance | null = null;

export function setMessageApi(api: MessageInstance) {
  messageApi = api;
}
